import '../../styles/globals.css'
import { Box, Typography } from '@mui/material'
import karmaStyles from '../../styles/KarmaPool.module.css'
import { Fragment, useContext, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useKarmaPoolContext } from '../../state/KarmaPoolContext';
import { Paper, Grid } from '@mui/material';

import MembershipTeaserImage1 from '../../images/homepage/sign-up-teaser1.png';

import { InlineIcon } from '@iconify/react';
import FlashPlayer from '../dashboard/adobeanimate/FlashPlayer';


function HeaderWelcome() {
    return (
        <Typography variant="body2" sx={{ marginTop: "1.5rem" }}>
            Welcome to the <strong>Karma Pool</strong>, the collective giving app that boosts charitable giving.
        </Typography>
    );
}

function InfoBox() {
    const karmaContext = useKarmaPoolContext();

    const [members, setMembers] = useState(() => {
        return 0;
    });

    const [donated, setDonated] = useState(() => {
        return 0;
    });

    useEffect(() => {
        setMembers(karmaContext.local.pool.members);
        setDonated(karmaContext.local.pool.gbpGivenByPool);
    }, [karmaContext.local.pool]);

    return (
        <Box className="info-box" sx={{ maxWidth: "24rem", minWidth: "14rem", width: "65%", margin: "auto", marginTop: "0.0rem" }}>
            <Grid container spacing={0} sx={{ justifyContent: "center" }}>
                <Grid item md={5} sm={12} xs={12}>
                    <Box className="info-row" sx={{ display: "flex", float: { xs: "none", md: "right" }, paddingRight: { xs: "0", md: "0.0rem" } }}>
                        <Typography variant="body2" sx={{ textAlign: "center", marginTop: "0.325rem", marginLeft: "0.1625rem" }}>
                        were moving to help
                        </Typography>
                    </Box>
                </Grid>

                <Grid item md={7} sm={12}>
                    <Box className="info-row" sx={{ display: "flex", float: { xs: "none", md: "center" }, paddingLeft: { xs: "0", md: "0.0rem" } }}>
                        <Typography variant="h6" sx={{ textAlign: "center", marginRight: "0.1625rem" }}>
                            £{donated == null ? "0.00" : donated.toFixed(2)}
                        </Typography>
                        <Typography variant="body2" sx={{ textAlign: "center", marginLeft: "0.1625rem" }}>
                            donated so far
                        </Typography>
                    </Box>
                </Grid>

            </Grid>
        </Box>
    );
}

function LoginRegisterButtons() {
    return (
        <Box className={karmaStyles.loginRegisterBox} sx={{ marginTop: "0.75rem", marginBottom: "0.25rem" }}>
            <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", marginTop: "0.25rem" }}>
                <Typography variant="body2" sx={{ textAlign: "center", marginRight: "0.25rem" }}>
                    <Link to='/karma/login' className={karmaStyles.homepageLoginRegisterAnchor}>
                        Log in
                    </Link>
                </Typography>
                <Typography variant="h6" sx={{ textAlign: "center" }}>
                    &nbsp;|&nbsp;
                </Typography>
                <Typography variant="body2" sx={{ textAlign: "center", marginLeft: "0.25rem" }}>
                    <Link to='/karma/register' className={karmaStyles.homepageLoginRegisterAnchor}>
                        Register
                    </Link>
                </Typography>
            </Box>
        </Box>
    );
}

function BackButton() {
    return (
        <Box>
            <p className={karmaStyles.homepageDescription}>
                <a href={"/"}>
                    back
                </a>
            </p>
        </Box>
    );
}

function HomepageRoot(props) {

    // access provider context for karma pool
    const karmaContext = useKarmaPoolContext();

    const [redirecting, setRedirecting] = useState(false);

    useEffect(() => {
        if (window.localStorage.getItem("jwtAuthToken") != null) {
            setRedirecting(true);
            //window.location.href = "/karma/dashboard";
            karmaContext.authPingManager.authPingSuccess(() => {
                console.log("auth ping success")
                window.location.href = "/karma/dashboard";
            });
        }
    }, []);

    return (
        <>
            <Box className={karmaStyles.homepageBox} sx={{ paddingRight: "1rem", paddingLeft: "1rem" }}>
                <HeaderWelcome />
                {/*<Box sx={{width: "100%", justifyContent: "center", display: "flex", marginTop: "0.5rem"}}>
                    <FlashPlayer width={'320px'} height={'140px'} swfTarget={'karma_pool_intro1.swf'}/>
                </Box> */}
                <Typography variant="body2" sx={{ color: "whitesmoke", fontSize: "0.825rem", marginBottom: "1rem", marginTop: "0.75rem" }}>

                        <a href={'/karma/about'} >
                            <u><strong>Learn More..</strong></u>
                        </a>
                </Typography>
                <InfoBox />
                <Box sx={{ height: "0.5em" }} />
                <LoginRegisterButtons />
                <Box sx={{ height: "0.275em" }} />
            </Box>
            <Typography variant="body1" sx={{ textAlign: "center", marginTop: "1.125rem" }}>
                
                <a href={'https://twitter.com/karma_pool_'} target="_blank" rel="noopener noreferrer">
                    <InlineIcon className="red-icon" icon="bi:twitter" style={{ fontSize: '1.25rem' }} />
                </a>
                <Paper sx={{ margin: "0.75rem", display: "inline-block" }} />
                <a href={'https://www.instagram.com/karma.pool/'} target="_blank" rel="noopener noreferrer">
                    <InlineIcon className="red-icon" icon="grommet-icons:instagram" style={{ fontSize: '1.25rem' }} />
                </a>
                <Paper sx={{ margin: "0.75rem", display: "inline-block" }} />
                <a href={'https://www.threads.net/@karma.pool'} target="_blank" rel="noopener noreferrer">
                    <InlineIcon className="red-icon" icon="fa6-brands:threads" style={{ fontSize: '1.25rem' }} />
                </a>
            </Typography>

            <Box sx={{ height: "1.375rem" }} />
            <BackButton />
        </>
    );
}

export default HomepageRoot;


